import React, { FC, useState } from 'react';
import { useLazyLoading } from '../_common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Routes } from '../../utils';
import { Loading } from '../_common';
import { useStoreContext } from '../App/StoreProvider';
import * as MessageListActions from '../../store/actions/messageList';
import { useParams } from 'react-router-dom';

interface LooseObject {
    [key: string]: any;
}

interface MessageDriverListProps {
    drivers: LooseObject[];
    refetch?: () => void;
    isLoading: boolean;
    isEndOfResults: boolean;
    history: any;
    match: any;
    redirectToConversationHandler: (event, driver) => void;
    redirectToGroupConversationHandler: (event, driver) => void;
    onLoadMore: () => void;
}

const MessageDriverList: FC<MessageDriverListProps> = ({
    drivers,
    refetch,
    isLoading,
    isEndOfResults,
    history,
    match,
    redirectToConversationHandler,
    redirectToGroupConversationHandler,
    onLoadMore,
}: MessageDriverListProps): React.ReactElement => {
    const [state, dispatch] = useStoreContext();
    const { handleScroll, scrollPos, setScrollPos } = useLazyLoading(
        'messageList',
        isLoading,
        isEndOfResults,
        onLoadMore,
    );
    const {messageId} = useParams();
    if (isLoading) {
        return <Loading />;
    }
    const doc: HTMLElement | null = document.getElementById('messageList');
    if (doc) {
        doc.scroll(0, scrollPos);
    }
    
    if (drivers.length > 0) {
        return (
            <div id="messageList" className="Message-List" onScroll={handleScroll}>
                <div className="Message">
                    {drivers.map(
                        (driver, index) => {
                            // if (driver.isGrupAl) {
                            //     return (
                            //         <div
                            //             key={`${driver.conversatonId}-${index}`}
                            //             className={
                            //                 match.params.messageId && driver.conversatonId == match.params.messageId
                            //                     ? 'conversation selected'
                            //                     : 'conversation'
                            //             }
                            //             onClick={event => {
                            //                 dispatch(MessageListActions.setDateFilter('ONEWEEK'));
                            //                 redirectToGroupConversationHandler(event, driver);
                            //                 setScrollPos(0);
                            //             }}
                            //         >
                            //             <div className="row">
                            //                 <div className="col-sm-8 my-auto">
                            //                     <div className="by">{driver.conversationName}</div>
                            //                 </div>
                            //                 <div className="col-sm-4 my-auto pl-0">
                            //                     <div className="row ml-0 mr-0 justify-content-between">
                            //                         <span className="conv-icon read">
                            //                             <FontAwesomeIcon icon={['fas', 'circle']} color="#fff" />
                            //                         </span>
                            //                         <span className="conv-icon on-shift">
                            //                             <FontAwesomeIcon icon={['fas', 'users']} />
                            //                         </span>
                            //                         {/* {driver.markAllRead ? (
                            //                             <span className="conv-icon read">
                            //                                 <FontAwesomeIcon icon={['fas', 'circle']} color="#fff" />
                            //                             </span>
                            //                         ) : driver.lastMessageRead !== driver.lastMessageId ? (
                            //                             <span className="conv-icon unread">
                            //                                 <FontAwesomeIcon icon={['fas', 'circle']} color="#b6bd00" />
                            //                             </span>
                            //                         ) : (
                            //                             <span className="conv-icon read">
                            //                                 <FontAwesomeIcon icon={['fas', 'circle']} color="#fff" />
                            //                             </span>
                            //                         )} */}
                            //                         {driver.isRead ? (
                            //                             <span className="conv-icon read">
                            //                                 <FontAwesomeIcon icon={['fas', 'circle']} color="#fff" />
                            //                             </span>
                            //                         ) : (
                            //                             <span className="conv-icon unread">
                            //                                 <FontAwesomeIcon icon={['fas', 'circle']} color="#b6bd00" />
                            //                             </span>
                            //                         )}
                            //                     </div>
                            //                 </div>
                            //             </div>
                            //         </div>
                            //     );
                            // } else {
                            return (
                                <div
                                    key={`${driver.resultId}-${index}`}
                                    className={
                                        messageId &&
                                        (driver.id == messageId ||
                                            driver.resultId == messageId ||
                                            driver.conversationId == messageId)
                                            ? 'conversation selected'
                                            : 'conversation'
                                    }
                                    onClick={event => {
                                        if (
                                            messageId &&
                                            (driver.id == messageId ||
                                                driver.resultId == messageId ||
                                                driver.conversationId == messageId)
                                        ) {
                                            return false;
                                        }
                                        // dispatch(MessageListActions.setDateFilter('ONEWEEK'));
                                        redirectToConversationHandler(event, driver);
                                        setScrollPos(0);
                                    }}
                                >
                                    <div className="Row justify-content-between" style={{ position: 'relative' }}>
                                        <div className="driver-unread-wrapper">
                                            {driver.isRead ? (
                                                <span className="conv-icon read">
                                                    <FontAwesomeIcon icon={['fas', 'circle']} color="#fff" />
                                                </span>
                                            ) : (
                                                <span className="conv-icon unread">
                                                    <FontAwesomeIcon icon={['fas', 'circle']} color="#b6bd00" />
                                                </span>
                                            )}
                                        </div>
                                        <div className="driver-info-wrapper">
                                            <div className="by">
                                                {(driver.driver && driver.driver.name) ||
                                                    driver.name ||
                                                    driver.driverName}
                                                    &nbsp;
                                                {driver.IsAvailable === false && (
                                                <span
                                                    className="conv-icon off-shift"
                                                    title="Driver not available"
                                                >
                                                    <FontAwesomeIcon icon={['fas', 'ban']} color="#FF0000"/>
                                                </span>
                                                )}
                                            
                                                {(driver.CheckInWithBellyDump ? (
                                                    <span
                                                        className="conv-icon on-shift"
                                                        title="Checked in with belly dump (hopper)"
                                                    >
                                                        <FontAwesomeIcon icon={['fas', 'dumpster']} color="#b6bd00" />
                                                    </span>
                                                ) : (
                                                    <span
                                                        className="conv-icon on-shift"
                                                        title="Checked in with box"
                                                    >
                                                        <FontAwesomeIcon icon={['fas', 'cube']} color="#b6bd00" />
                                                    </span>
                                                ))}
                                            </div>

                                            <div className="type">
                                                {driver.driverCompanyName || driver.driver.driverCompanyName}
                                            </div>
                                        </div>
                                        <div className="Row driver-status-wrapper justify-content-between">
                                            {/* <div className="Row ml-0 mr-0 justify-content-between"> */}
                                            {driver.isAssigned ? (
                                                <span className="conv-icon on-shift">
                                                    <FontAwesomeIcon icon={['fas', 'truck-moving']} />
                                                </span>
                                            ) : driver.isWaitingOnLoad ? (
                                                <span className="conv-icon waiting-on-load">
                                                    <FontAwesomeIcon icon={['fas', 'clock']} />
                                                </span>
                                            ) : driver.isLastLoadRejected && driver.isShiftStarted ? (
                                                <span className="material-icons LoadItem-RejectedIcon">
                                                    <i className="material-icons LoadItem-RejectedIcon">cancel</i>
                                                </span>
                                            ) : (
                                                <span className="conv-icon read">
                                                    <FontAwesomeIcon icon={['fas', 'circle']} color="#fff" />
                                                </span>
                                            )}

                                            {driver.isShiftStarted ? (
                                                <span className="conv-icon on-shift">
                                                    <FontAwesomeIcon icon={['fas', 'user-clock']} />
                                                </span>
                                            ) : (
                                                <span className="conv-icon off-shift">
                                                    <FontAwesomeIcon icon={['fas', 'user']} />
                                                </span>
                                            )}


                                            {/* </div> */}
                                        </div>
                                    </div>
                                </div>
                            );
                        },
                        // }
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <div id="messageList" className="Message-List">
                <div className="Message">
                    <div className="no-conversation my-auto text-center justify-content-center align-self-center">
                        No Driver Data found !!
                    </div>
                </div>
            </div>
        );
    }
};

export default MessageDriverList;
